import {getInstance} from '../auth/index'

const investor = getInstance()
export default {
  getGroupItems: function (groupName)
  {
    try
    {
      if (investor && investor.isAuthenticated)
      {
        if (investor.classificators && investor.classificators.length)
        {
          return investor.classificators.filter(f => f.group_name === groupName)
        }
      }
    }
    catch (e)
    {
      console.log('Investor data get failed', e)
      return null
    }
  },
  getShortNameById(groupName, itemId)
  {
    const items = this.getGroupItems(groupName)
    if (items)
    {
      const item = items.filter(i => i.id === parseInt(itemId))
      if (item && item[0] && item[0].short_name)
      {
        return item[0].short_name
      }
    }
  },
  getNameById(groupName, itemId)
  {
    const items = this.getGroupItems(groupName)
    if (items)
    {
      const item = items.filter(i => i.id === parseInt(itemId))
      if (item && item[0] && item[0].name)
      {
        return item[0].name
      }
    }
  },
  getNameByShortName(groupName, shortName)
  {
    const items = this.getGroupItems(groupName)
    if (items)
    {
      const item = items.filter(i => i.short_name === shortName)
      if (item && item[0] && item[0].name)
      {
        return item[0].name
      }
    }
  },
  getGroupItemsAsOptions(groupName)
  {
    const resultOptions = []
    const options = this.getGroupItems(groupName)
    // console.log('Got options (' + groupName + ':'); console.log(options)
    if (options)
    {
      options.forEach((option) =>
      {
         if (option.label_i18n) {
           resultOptions.push({ text: option.label_i18n, value: option.name, label_i18n: option.label_i18n })
         } else {
          resultOptions.push({ text: option.label, value: option.name })
         }
      })
    }
    // console.log('Results:', resultOptions)
    return resultOptions
  },
  getCountriesWithPopularInTop()
  {
    let allCountries = this.getGroupItems('COUNTRY')
    let popularCountries = this.getGroupItems('POPULAR_COUNTRY')
    if (popularCountries)
    {
      // separator with empty value
      allCountries.unshift({name: ' '})
      const popularCountryNames = popularCountries.map(c => c.short_name)
      popularCountries = allCountries.filter(c => popularCountryNames.indexOf(c.short_name) !== -1)
      allCountries = allCountries.filter(c => popularCountryNames.indexOf(c.short_name) === -1)
      popularCountries.push(...allCountries)
      return popularCountries
    }
    return allCountries
  }
}
